import type { RouteRecordRaw } from "vue-router";
const onError = (err: any) => {
  console.error("Failed to load async component: ", err);
  throw new Error(err);
};

const Affiliate: RouteRecordRaw = {
  name: "渠道管理",
  path: "/affiliate",
  component: () => import("@/components/Layout/index.vue").catch(onError),
  meta: {
    key: "/affiliate"
  },
  children: [
    {
      name: "渠道列表",
      path: "aff-list",
      meta: {
        key: "/affiliate/aff-list",
        keepAlive: true
      },
      component: () =>
        import("@/views/Affiliate/AffList/index.vue").catch(onError)
    },
    /* {
      name: "渠道创建",
      path: "create",
      meta: {
        key: "/affiliate/create"
      },
      component: () =>
        import("@/views/Affiliate/AffPanel/index.vue").catch(onError)
    }, */
    {
      name: "渠道签约详情",
      path: "sign-detail",
      meta: {
        key: "/affiliate/sign-detail"
      },
      component: () =>
        import("@/views/Affiliate/AffDetail/SignDetail.vue").catch(onError)
    },
    {
      name: "映射关系管理",
      path: "mapping-relation",
      meta: {
        key: "/affiliate/mapping-relation",
        keepAlive: true
      },
      component: () =>
        import("@/views/Affiliate/MappingRelation/index.vue").catch(onError)
    },
    {
      name: "下游下发日志",
      path: "aff-postback-log",
      component: () =>
        import("@/views/Affiliate/AffPostbackLog/index.vue").catch(onError),
      meta: {
        key: "/affiliate/aff-postback-log"
      }
    },
    {
      name: "合作状态查询",
      path: "cooperation-status-list",
      meta: {
        key: "/affiliate/cooperation-status-list"
      },
      component: () =>
        import("@/views/Affiliate/CooperationStatusList/index.vue").catch(
          onError
        )
    },
    {
      name: "PID共用",
      path: "pid-share",
      meta: {
        key: "/affiliate/pid-share",
        keepAlive: true
      },
      component: () =>
        import("@/views/Affiliate/PidShare/index.vue").catch(onError)
    }
  ]
};

export default Affiliate;
